module.exports = __webpack_public_path__ + "static/icon-quota.dbba5738.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/festival/icon-quota.png
// module id = 275
// module chunks = 2